module.exports = __webpack_public_path__ + "static/media/help.c3f45a39.svg";